// extracted by mini-css-extract-plugin
export default {"blockquote":"Quote_blockquote__hmzn1"};